export default (val, clean = false) => {
  const alphaNum = val ? val.replace(/\W/g, "").toUpperCase() : "";

  if (clean) {
    return alphaNum;
  }

  // CNPJ (14 chars, pode ser alfanumérico)
  if (alphaNum.length === 14) {
    return alphaNum.replace(
      /^([A-Z0-9]{2})([A-Z0-9]{3})?([A-Z0-9]{3})?([A-Z0-9]{4})?(\d{2})?/i,
      "$1.$2.$3/$4-$5",
    );
  }

  // CPF (11 dígitos, sempre numérico)
  const num = alphaNum.replace(/\D/g, "");
  if (num.length !== 11) {
    return num;
  }
  return num.replace(/^(\d{3})(\d{3})?(\d{3})?(\d{2})?/, "$1.$2.$3-$4");
};
